import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

export interface StylesDescriptor {
  block?: boolean;
  color?: string;
  background?: string;
  border?: string;
  transparent?: boolean;
}

export enum ButtonType {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  OrderingPrimary = 'ordering-primary',
  OrderingSecondary = 'ordering-secondary',
  Custom = 'custom',
}

@Component({
  name: 'CmgButton',
})
export default class CmgButton extends Vue {
  @Prop({ type: String })
  public background?: string;

  @Prop({ type: String })
  public color?: string;

  @Prop({ type: String })
  public border?: string;

  @Prop({ type: String })
  public focusBack?: string;

  @Prop({ type: String })
  public decoratorClass?: string;

  @Prop({ required: false, default: '', type: String })
  ariaLabel!: string;

  @Prop({ default: false, type: Boolean })
  public block!: boolean;

  @Prop({ default: 'md', type: String })
  public height!: 'sm' | 'md' | 'lg' | 'unset';

  @Prop({ default: false, type: Boolean })
  public transparent!: boolean;

  @Prop({ default: 'primary', type: String })
  public type!: ButtonType;

  @Prop({ default: false, type: Boolean })
  public disabled!: boolean;

  @Prop({ default: false, type: Boolean })
  public loading!: boolean;

  get containerStyles(): object {
    const styles = this.getStylesDescriptor();

    return {
      block: styles.block,
      transparent: styles.transparent,
      [`size-${this.height}`]: true,
      ['has-border']: !!styles.border,
      [`type-${this.type}`]: true,
      loading: this.loading,
      ...(styles.border ? { [`border-color-${styles.border}`]: true } : {}),
      ...(styles.background ? { [`bg-${styles.background}`]: !this.transparent } : {}),
    };
  }

  get contentStyles(): object {
    const styles = this.getStylesDescriptor();

    return {
      ...(styles.color ? { [`color-${styles.color}`]: true } : {}),
    };
  }

  getStylesDescriptor(): StylesDescriptor {
    const styles: StylesDescriptor = {
      block: this.block,
      color: this.resolveColor(),
      background: this.resolveBackground(),
      border: this.resolveBorder(),
      transparent: this.resolveTransparency(),
    };

    return styles;
  }

  resolveColor(): string | undefined {
    return this.type == 'custom' ? this.color : undefined;
  }

  resolveBackground(): string | undefined {
    return this.type == 'custom' ? this.background : undefined;
  }

  resolveBorder(): string | undefined {
    const border = this.resolveBorderColor();

    return border === 'none' ? '' : border || this.resolveBackground();
  }

  resolveBorderColor(): string | undefined {
    return this.type == 'custom' ? this.border : undefined;
  }

  resolveTransparency(): boolean {
    return this.type == 'custom' ? this.transparent : false;
  }

  onClick($event: MouseEvent) {
    if (!this.disabled) {
      this.$emit('click', $event);
    }
  }

  onFocus($event: Event) {
    if (!this.disabled) {
      this.$emit('focus', $event);
    }
  }

  onBlur($event: Event) {
    if (!this.disabled) {
      this.$emit('blur', $event);
    }
  }
}
